// Links behind biorlabs.com/download/<source>.
//
// One source label per place a link is shared. The list is closed and is the
// same list (the KPI spec's) the backend accepts at POST /api/download-click.
// Anything else becomes "unknown" and still redirects.
export const DOWNLOAD_SOURCES = [
  "x-biorlabs",
  "goatskey",
  "tiktok",
  "linkedin",
  "telegram",
  "linktree",
  "site",
];
export const UNKNOWN_SOURCE = "unknown";

export const APP_STORE_APP_URL = "https://apps.apple.com/app/id6743424304";
export const PLAY_STORE_PACKAGE_ID = "com.app.biorbankapp";
export const PLAY_STORE_APP_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE_ID}`;

export function normalizeSource(source) {
  const value = String(source || "").trim().toLowerCase();
  return DOWNLOAD_SOURCES.includes(value) ? value : UNKNOWN_SOURCE;
}

// App Store Connect campaign link: pt is the provider token (set at build time,
// REACT_APP_APPSTORE_PT), ct is the campaign name, here the source.
export function iosUrl(source) {
  const ct = normalizeSource(source);
  // CRA only inlines the variable when it is referenced by its full name.
  const pt = (process.env.REACT_APP_APPSTORE_PT || "").trim();
  const query = [];
  if (pt) query.push(`pt=${encodeURIComponent(pt)}`);
  query.push(`ct=${encodeURIComponent(ct)}`, "mt=8");
  return `${APP_STORE_APP_URL}?${query.join("&")}`;
}

// Google Play passes the "referrer" value to the app's Install Referrer API.
// The value is itself a query string, so it is encoded once as a whole.
export function androidUrl(source) {
  const s = normalizeSource(source);
  const referrer = `utm_source=${s}&utm_medium=download_link&utm_campaign=${s}`;
  return `${PLAY_STORE_APP_URL}&referrer=${encodeURIComponent(referrer)}`;
}

export function desktopUrl(source) {
  return `/?utm_source=${encodeURIComponent(normalizeSource(source))}`;
}

// "android" | "ios" | "desktop" | "other", from the user agent alone.
export function detectPlatform(userAgent, { maxTouchPoints = 0 } = {}) {
  const ua = String(userAgent || "");
  if (/android/i.test(ua)) return "android";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  // iPadOS Safari presents itself as a Mac; touch points tell them apart.
  if (/Macintosh/i.test(ua) && maxTouchPoints > 1) return "ios";
  if (/Windows|Macintosh|X11|Linux|CrOS/i.test(ua)) return "desktop";
  return "other";
}

// The site's own store buttons name the store they mean (a desktop visitor who
// clicks "App Store" wants the App Store, not the home page).
export function downloadPath(store) {
  return `/download/site?store=${store}`;
}

export function resolveDownload({ source, store, userAgent, maxTouchPoints } = {}) {
  const s = normalizeSource(source);
  const platform =
    store === "ios" || store === "android" ? store : detectPlatform(userAgent, { maxTouchPoints });
  let url;
  if (platform === "ios") url = iosUrl(s);
  else if (platform === "android") url = androidUrl(s);
  else url = desktopUrl(s);
  return { source: s, platform, url };
}
